import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=4b2f4ac0&scoped=true&"
import script from "./Security.vue?vue&type=script&lang=js&"
export * from "./Security.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2f4ac0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b2f4ac0')) {
      api.createRecord('4b2f4ac0', component.options)
    } else {
      api.reload('4b2f4ac0', component.options)
    }
    module.hot.accept("./Security.vue?vue&type=template&id=4b2f4ac0&scoped=true&", function () {
      api.rerender('4b2f4ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/settings/Security.vue"
export default component.exports